import { Text } from '@shared/components'
import { displayDate, displayTime } from '@shared/utils'
import { isToday, isYesterday } from '@shared/utils'
import { Flex, FlexProps } from 'antd'
import { TextProps } from 'antd/es/typography/Text'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

type Props = {
  date?: string | null
  textProps?: Omit<TextProps, 'color'>
} & Omit<FlexProps, 'children'>

export const DayLabel = ({ date, textProps, ...props }: Props) => {
  const { t } = useTranslation()

  const getCurrentDayLabel = (date: string) => {
    const isValidDate = dayjs(date).isValid()
    if (!isValidDate) return { day: null, time: null }

    const time = displayTime(date)

    const today = isToday(date) ? t('today_at') : null
    const yesterday = isYesterday(date) ? t('yesterday_at') : null

    const day = today || yesterday || displayDate(date)

    return {
      day,
      time
    }
  }

  if (!date) return '-'

  const { day, time } = getCurrentDayLabel(date)
  if (!day || !time) return '-'

  return (
    <Flex
      gap={4}
      align="center"
      wrap="nowrap"
      style={{ whiteSpace: 'nowrap' }}
      {...props}
    >
      <Text {...textProps}>
        {day} {time}
      </Text>
    </Flex>
  )
}
